import Image from 'next/image';

import { useWindow } from 'hooks/useWindow';
import { BOOKING_LINK, media } from '../constants';
import {
  ThankYouDescription,
  ThankYouImageWrapper,
  ThankYouWrapper,
} from './thankYou.styled';

function ThankYouMessage() {
  const { w: width } = useWindow();

  return (
    <ThankYouWrapper>
      <ThankYouImageWrapper>
        <Image
          src={media.thankYouImage}
          width={width > 768 ? 174 : 146}
          height={width > 768 ? 174 : 146}
          alt="Thank you"
        />
      </ThankYouImageWrapper>
      <ThankYouDescription>
        <h1>Thank You!</h1>
        <p>
          Someone from Richr will be in touch soon. In the meantime, you can{' '}
          <a href={BOOKING_LINK}>book time with Richr here.</a>
        </p>
      </ThankYouDescription>
    </ThankYouWrapper>
  );
}

export default ThankYouMessage;
